// extracted by mini-css-extract-plugin
module.exports = {"swiper_nav_buttons":"SwiperNavButtons_swiper_nav_buttons__2GapM","prev":"SwiperNavButtons_prev__2DXnb","next":"SwiperNavButtons_next__3tFOt"};